module.exports = __webpack_public_path__ + "static/media/7.f0e3e750.jpg";